const filterCampaigns = (campaigns, isMember) => {
  return campaigns.filter(
    (campaign) =>
      campaign?.properties?.title &&
      campaign?.url &&
      campaign?.properties?.thumbnailUrl &&
      (isMember || campaign?.target !== 'member')
  )
}

const sortCampaigns = (campaigns) =>
  campaigns.sort((a, b) => {
    // Priority 1 = shown first, 2 = shown second, etc. No priority is shown after all featured campaigns.
    const priorityA = a.properties?.priority ? parseInt(a.properties?.priority, 10) : Number.MAX_SAFE_INTEGER
    const priorityB = b.properties?.priority ? parseInt(b.properties?.priority, 10) : Number.MAX_SAFE_INTEGER
    if (priorityA !== priorityB) {
      return priorityA - priorityB
    }

    // If priorities are equal, compare titles
    return a.properties.title.localeCompare(b.properties.title, undefined, { sensitivity: 'base' })
  })

const deduplicateCampaigns = (campaigns) => {
  const uniqueCampaignsByUrl = [...new Map(campaigns.map((c) => [c.url, c])).values()]
  return uniqueCampaignsByUrl
}

const campaignTile = (campaign) => ({
  link: campaign.url,
  id: campaign.id,
  dismissable: false,
  splash: 'external',
  imageUrl: campaign.properties.thumbnailUrl,
  title: campaign.properties.title,
  description: campaign.properties.description,
  borderColor: campaign.properties.borderColor,
  constrainedImage: false,
})

// Transform an array of campaigns (from the SNA userSummary or campaignSummary endpoint) into an array of objects the activity groups grids
export default function processCampaigns(campaigns, isMember = false) {
  if (!campaigns?.length) return []
  return sortCampaigns(deduplicateCampaigns(filterCampaigns(campaigns, isMember))).map(campaignTile)
}
